import React, { useState, useCallback, useEffect } from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import { calcWeightData } from '../../utils/miscUtil';
import HSEHazardGraph from './HSEHazardGraph'

const filter_fields = [
  "15", "18", "28", "31", //Hazard
  "16", "19", "29", "32", //Operation
];

export default function HSEHazard(props) {
  const [originalData, setOriginalData] = useState();
  const [weightData, setWeightData] = useState({});
  const [weight, setWeight] = useState("Oil & Gas Weighted");

  useEffect(() => {
    setWeightData(calcWeightData(props.data, props.year));
    var fd = props.data.filter((e) => {return filter_fields.includes(e["Identifier"])});
    for (var i=0; i<fd.length; i++) {
      fd[i]['company_'+fd[i].company_id] = parseFloat(fd[i].value?.replaceAll(",","")) || null;
      fd[i]['date'] = new Date(fd[i]['year'], 0)
    }
    setOriginalData(fd);
  }, [props.data, props.year]);

  const onWeightChanged = useCallback((e) => {
    setWeight(e.value);
  }, [setWeight])

  return (
    <>
      <div className="d-flex flex-column">
        <SelectBox
            dataSource={["Gas Weighted", "Oil Weighted", "Oil & Gas Weighted"]}
            value={weight}
            width="300px"
            showDropDownButton={true}
            activeStateEnabled={true}
            onValueChanged={onWeightChanged}
            label={"Gas/Oil Weighted"}
            labelMode="floating"
            placeholder={"Gas/Oil Weighted"}
            noDataText={"Select a metric first"}
        >
        </SelectBox>
        <h2 className="mt-3">SIFs</h2>
        <div className="d-flex flex-row">
          <HSEHazardGraph data={originalData} metricId="18" title="Employee Hazard Type" weightData={weightData} weight={weight}/>
          <HSEHazardGraph data={originalData} metricId="31" title="Contractor Hazard Type" weightData={weightData} weight={weight}/>
        </div>
        <div className="d-flex flex-row">
          <HSEHazardGraph data={originalData} metricId="19" title="Employee Operation Type" weightData={weightData} weight={weight}/>
          <HSEHazardGraph data={originalData} metricId="32" title="Contractor Operation Type" weightData={weightData} weight={weight}/>
        </div>
        <h2 className="mt-5">Fatalities</h2>
        <div className="d-flex flex-row">
          <HSEHazardGraph data={originalData} metricId="15" title="Employee Hazard Type" weightData={weightData} weight={weight}/>
          <HSEHazardGraph data={originalData} metricId="28" title="Contractor Hazard Type" weightData={weightData} weight={weight}/>
        </div>
        <div className="d-flex flex-row">
          <HSEHazardGraph data={originalData} metricId="16" title="Employee Operation Type" weightData={weightData} weight={weight}/>
          <HSEHazardGraph data={originalData} metricId="29" title="Contractor Operation Type" weightData={weightData} weight={weight}/>
        </div>
      </div>
    </>
  );
}
